module.exports = __webpack_public_path__ + "img/Oversiktsbilde.e178b22b.png";